//Core Modules
import React from "react";

//External Modules
import cx from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck, faDotCircle} from "@fortawesome/free-regular-svg-icons";

const ImportSteps = ({steps, currentStep}) => {

    const stepsLength = steps.length;

    return(
        <div className={`import-steps w-100 text-center`}>
            <div className={`import-stage-wrapper`}>
                <ul className={`import-stage`}>
                    {
                        steps.map((value,index)=>{

                            const val = index + 1;
                            const icon = Number(currentStep) > val ? faCircleCheck : faDotCircle;
                            const isBold = Number(currentStep) >= val;
                            const isCompleted = Number(currentStep) > val;
                            const isLast = stepsLength === val;

                            return (
                                <li className={cx(`import-stage-list`,{
                                    "flex-1" : !isLast
                                })}>
                                    <div className={cx(`import-stage-list-stripe`,{
                                        'completed' : isCompleted
                                    })}>
                                        <div />
                                    </div>
                                    <FontAwesomeIcon className={cx(`import-stage-point`,{
                                        'completed' : isCompleted
                                    })} icon={icon} />
                                    <span className={cx(`import-stage-title`,
                                        {'bold' : isBold, "w-20" : isLast, 'active' : isBold}
                                    )}>{value}</span>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    );
}

export default ImportSteps;